import React, {useRef} from "react";
import {Auth} from "aws-amplify";
import Link from '@mui/material/Link';
import {Link as RouterLink} from 'react-router-dom';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import {useAppContext} from "../libs/appContextLib";
import {Helmet} from 'react-helmet-async';
import {QLoadingProgressBars} from "../components/Loaders/QLoadingProgressBars";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import {config} from "../config";
import Container from "@mui/material/Container";
import { Alert, AlertTitle } from '@mui/material';
import Divider from "@mui/material/Divider";
import qs from "qs";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Hidden from "@mui/material/Hidden";
import LoginScreenPassword from "./LoginScreenPassword";
import {get} from 'lodash';
import axios from "axios";
import {useQueryClient} from "@tanstack/react-query";

export default function LoginScreen(props) {


    const {setIsAuthenticated} = useAppContext();
    const [isLoading, setIsLoading] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [formDisabled, setFormDisabled] = React.useState(true);
    const [stepOneDisabled, setStepOneDisabled] = React.useState(true);
    const [password, setPassword] = React.useState("");
    const [userDetails, setUserDetails] = React.useState("");
    const [codeSent, setCodeSent] = React.useState(false);
    const [code, setCode] = React.useState("")
    const [isConfirming, setIsConfirming] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(false);


    const [passwordVisibility, setPasswordVisibility] = React.useState(
        {
            password: false,
        }
    )

    const handleTogglePasswordVisibility = (e, passwordType) => {
        setPasswordVisibility({
            ...passwordVisibility,
            [passwordType]: !passwordVisibility[passwordType]
        })
    }

    const handleError = (errors) => {
        console.log("handleError", errors)
        setFormDisabled(true)
    }


    const validatorListener = (result) => {

        setFormDisabled(!result);
    }

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function validateForm() {
        return email.length > 0 && ((preAuthUserStatus === 'built-in_or_okta-oidc' || preAuthUserStatus === 'built-in') ? password.length > 0 : true);
    }

    function validateConfirmForm() {
        return code.length > 0;
    }

    const queryClient = useQueryClient();

    async function handleConfirmClick(event) {
        // event.preventDefault();
        setIsConfirming(true);
        await Auth.verifyCurrentUserAttributeSubmit("email", code)
            .then(() =>
                Auth.currentAuthenticatedUser({bypassCache: true}).then(() => {
                        onLoad()
                        setIsAuthenticated(true)
                    }
                ))

            .catch((error) => {
                console.log("confirmation code error:", error);
                setIsConfirming(false);
            })
    }

    const handleCodeFieldChange = event => {
        setCode(event.target.value);
    };

    const handleEmailFieldChange = event => {
        let emailStr = event.target.value.replace(/\s+/g, '').toLowerCase();
        // let checkEmailValid = validateEmail(emailStr)
        setEmail(emailStr)

    };

    const handlePasswordFieldChange = event => {
        setPassword(event.target.value);
    };


    async function beginEmailVerification() {
        // try {
        const user = await Auth.currentAuthenticatedUser();
        // alert("LoginScreen: beginEmailVerification: currentAuthenticatedUser()")

        await Auth.verifyUserAttribute(user, "email");
        setCodeSent(true);
    }

    const {onLoad} = useAppContext()

    const [preAuthUserStatus, setPreAuthUserStatus] = React.useState()

    const checkUserStatusForLogin = async (event) => {
        setErrorMessage('')
        setIsLoading(true);
        axios.get(`${config.REACT_APP_BACKEND_HOST}/authentication/check-user`, {
            params: {
                user_email: email
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        }).then((response) => {


            let authPrefHistory = response.data.auth_preference
            let identityProviderName = get(response.data, "identity_provider[0]", undefined)



            if (authPrefHistory === 'not enabled') {
                // setErrorMessage("We couldn't find your QFlow.ai account.")
                setIsLoading(false)
            } else if (authPrefHistory.length > 0) {
                const authPrefToSet = authPrefHistory[authPrefHistory.length - 1].auth_preference
                setPreAuthUserStatus(authPrefToSet)
                if ((authPrefToSet === 'built-in' || authPrefToSet === 'built-in_or_okta-oidc') && !password || password.length === 0) {
                    setIsLoading(false)
                }
                if (authPrefToSet === 'okta-oidc' || authPrefToSet === 'google-oidc'  || authPrefToSet === 'built-in_or_google-oidc') {
                    console.log("identityProviderName", identityProviderName)
                    identityProviderName && localStorage.setItem("qIdentityProvider", identityProviderName)
                    Auth.federatedSignIn({provider: identityProviderName})

                } else if ((authPrefToSet === 'built-in' || authPrefToSet === 'built-in_or_okta-oidc' || authPrefToSet === 'built-in_or_google-oidc') && password && password.length > 0) {
                    handleSubmit(event)
                }
            } else {
                setErrorMessage("We couldn't find your QFlow.ai account.")
                setIsLoading(false);
            }
        }).catch((e) => {
            setIsLoading(false);
            const errorMsg = get(e, 'response.data.error', '')
            const errorMsgToSet = errorMsg.search("UsernameExistsException") > -1 ?
                <span>This user already exists. Please <Link style={{color: "#579FEE"}} component={RouterLink}
                                                             to='/login'><b>sign in</b></Link></span>
                : errorMsg.split(":")[1]
            !errorMsgToSet ?
                setErrorMessage("Something doesn't seem right. Contact your QFlow administrator.") :
                setErrorMessage(errorMsgToSet)
        })
    }

    const handleGoBack = event => {
        setPreAuthUserStatus('')
        setPassword('')
        setPasswordVisibility({password: false})
        setIsLoading(false)

    }


    const handleSignInWithGoogle = async event => {
        await Auth.signInWithRedirect({provider: "Google"})
    }


    const handleSubmit = async event => {

        event.preventDefault();
        setPasswordVisibility({password: false})
        setErrorMessage('')


        try {
            setIsLoading(true);
            await Auth.signIn(email, password).then(user => {
                setUserDetails(user)

                // alert("LoginScreen: handleSubmit(): Signed in")
                if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    const {requiredAttributes} = user.challengeParam;
                    const {userAttributes} = user.challengeParam;
                    const userDetails = JSON.stringify(user);


                    props.history.replace({
                        pathname: '/login/set-password', state: {
                            requiredAttributes: requiredAttributes,
                            userAttributes: userAttributes,
                            userDetails: userDetails

                        }
                    })



                }

            })
            let info = await Auth.currentAuthenticatedUser({bypassCache: true})

            if (info.attributes && (info.attributes['email_verified'] === false || !info.attributes['email_verified'])) {
                setIsAuthenticated(false)
                // alert("LoginScreen: handleSubmit(): Email not verified")

                beginEmailVerification()
                    .catch(e => {

                        setIsAuthenticated(false)
                    });
                setIsLoading(false)
            } else {
                // alert("LoginScreen: handleSubmit(): Email must be verified already?")
                setIsAuthenticated(true)
                onLoad()
            }

        } catch (e) {
            setIsLoading(false)
            setErrorMessage(e.message)
            // alert(e.message);
        }
    };

    const formRefOne = useRef(null);



    function renderConfirmationForm() {
        return (
            <div>

                <Paper
                    square
                    elevation={0}
                    style={{
                        width: "100%",
                        minHeight: "100vh",
                        paddingLeft: "1em",
                        paddingRight: "1em",
                        paddingTop: "3em"
                    }}>
                     <Grid container alignItems="flex-start" justifyContent="center" style={{paddingTop: '3em'}}>
                        <Hidden mdDown>
                            <Grid item xs={12} md={3}>
                                <Alert icon={false} severity='info'><AlertTitle>
                                    <Typography component="h2" variant="body1"><b>Introducing Scenario
                                        Sync</b>&nbsp;&nbsp;<span
                                        style={{
                                            textDecoration: "none",
                                            whiteSpace: "nowrap",
                                            borderRadius: "3px",
                                            backgroundColor: "#4093D7",
                                            color: "#FFF",
                                            fontWeight: 400,
                                            fontSize: "0.9em",
                                            textTransform: "uppercase"
                                        }}>&nbsp;&nbsp;New&nbsp;&nbsp;</span>
                                    </Typography>
                                </AlertTitle>
                                    <p>Sync the results of your rolling 12-month forecast directly to your team's Financial model. </p>

                                    <div style={{margin: 'auto', maxWidth: '75%'}}>
                                        <img width={'95%'} src='/sync-scenario.png'/>
                                    </div>
                                </Alert>
                            </Grid>
                        </Hidden>
                        <Grid item xs={12} md={8} lg={6}>


                            <Container>
                                <Grid container alignItems="center" justifyContent="center">
                                    <Grid item>
                                        <Grid item xs={12}>
                                            <Typography style={{textAlign: 'center'}} variant="h5"><b>Log in to your
                                                QFlow.ai account</b></Typography><br/>
                                        </Grid>

                                        <Grid item xs={12} sm={11}>
                                            <ValidatorForm ref={formRefOne} onSubmit={handleConfirmClick}
                                                           validatorListener={validatorListener}
                                                           noValidate
                                                           onError={(errors) => handleError(errors)}
                                                // instantValidate={true}
                                            >
                                                <FormGroup>

                                                    <TextValidator
                                                        label="Email"
                                                        variant={"standard"}
                                                        fullWidth
                                                        disabled={true}
                                                        // onChange={props.handleEmailFieldChange}
                                                        id="email"
                                                        autoFocus={true}
                                                        autoComplete="username"
                                                        autocomplete="username"
                                                        auto="username"
                                                        inputProps={{autocomplete: "username"}}
                                                        name="email"
                                                        // value={props.email}
                                                        onChange={handleEmailFieldChange}
                                                        value={email}
                                                        // defaultValue={props.email}
                                                        validators={['required', 'isEmail']}
                                                        errorMessages={['your email is required', 'email is not valid']}
                                                    />

                                                </FormGroup>
                                                <FormGroup>
                                                    <TextField
                                                        variant={"standard"}
                                                        id="password"
                                                        type="password"
                                                        autoFocus={true}
                                                        label="Password"
                                                        autoComplete="current-password"
                                                        value={password}
                                                        onChange={handlePasswordFieldChange}
                                                    />
                                                </FormGroup>
                                                <FormGroup>
                                                    <TextField
                                                        variant={"standard"}
                                                        autoFocus
                                                        label="Confirmation Code"
                                                        type="tel"
                                                        onChange={handleCodeFieldChange}
                                                    />
                                                    <Box pt={1}/>
                                                    <Alert severity='info'>
                                                        Please check your inbox for the
                                                        confirmation code.
                                                    </Alert>
                                                </FormGroup>
                                                <div style={{height: '10px'}}>{isConfirming &&
                                                    <QLoadingProgressBars/>
                                                }
                                                </div>
                                                <Grid item xs={3}>
                                                    <Box pt={1}/>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        disabled={isConfirming}
                                                        type="submit"
                                                        onClick={handleConfirmClick}>Confirm</Button>
                                                </Grid>
                                            </ValidatorForm>
                                        </Grid>
                                    </Grid></Grid>
                            </Container>
                        </Grid>
                    </Grid>
                </Paper>

            </div>
        );
    }

    function renderLoginForm() {
        return (
            <div>
                <Paper
                    square
                    elevation={0}
                    style={{
                        width: "100%",
                        minHeight: "100vh",
                        // paddingLeft: "1em",
                        // paddingRight: "1em",
                        paddingTop: "6em",
                        fontFamily: [
                            'Assistant, sans-serif',
                            '-apple-system',
                            'BlinkMacSystemFont',
                            '"Segoe UI"',
                            'Helvetica Neue',
                            'Arial',
                            'sans-serif',
                            '"Apple Color Emoji"',
                            '"Segoe UI Emoji"',
                            '"Segoe UI Symbol"',
                        ].join(','),
                    }}>
                    <Grid container alignItems="flex-start" justifyContent="center" style={{paddingTop: '3em'}}>
                        <Hidden mdDown>
                            <Grid item xs={12} md={3}>
                                <Alert icon={false} severity='info'><AlertTitle>
                                    <Typography component="h2" variant="body1"><b>Introducing Scenario
                                        Sync</b>&nbsp;&nbsp;<span
                                        style={{
                                            textDecoration: "none",
                                            whiteSpace: "nowrap",
                                            borderRadius: "3px",
                                            backgroundColor: "#4093D7",
                                            color: "#FFF",
                                            fontWeight: 400,
                                            fontSize: "0.9em",
                                            textTransform: "uppercase"
                                        }}>&nbsp;&nbsp;New&nbsp;&nbsp;</span>
                                    </Typography>
                                </AlertTitle>
                                    <p>Sync the results of your rolling 12-month forecast directly to your team's Financial model. Growth is better when teams work together.</p>

                                    <div style={{margin: 'auto', maxWidth: '100%'}}>
                                        <img width={'95%'} src='/sync-scenario.png'/>
                                    </div>
                                </Alert>
                            </Grid>
                        </Hidden>
                        <Grid item xs={12} md={9} lg={6}>
                            <Container>
                                <Grid container alignItems="center" xl={12} justifyContent="center">
                                    <Grid item xs={11} sm={6}>
                                        <Grid item xs={12}>
                                            <Typography variant="h5" component={"h1"}><b>Log in to your QFlow.ai
                                                account</b></Typography><br/>
                                        </Grid>
                                        <Grid item xs={12} sm={11}>

                                            <ValidatorForm
                                                ref={formRefOne}
                                                onSubmit={checkUserStatusForLogin}
                                                instantValidate={true}>
                                                <FormGroup>
                                                    <Grid container spacing={1} alignItems="flex-end">
                                                        <Grid item xs={1}>
                                                            {preAuthUserStatus && (preAuthUserStatus === 'built-in' || preAuthUserStatus === 'built-in_or_okta-oidc' || preAuthUserStatus === 'built-in_or_google-oidc') &&
                                                                <ArrowBack
                                                                    style={{cursor: 'pointer'}}
                                                                    onClick={(e) => handleGoBack(e)}
                                                                />
                                                            }
                                                        </Grid>
                                                        <Grid item xs={10}>
                                                            <TextValidator
                                                                label="Email"
                                                                inputProps={{}}
                                                                variant={"standard"}
                                                                id="email"
                                                                autoFocus={true}
                                                                autoComplete="username"
                                                                fullWidth
                                                                name="email"
                                                                disabled={isLoading || (preAuthUserStatus === 'built-in' || preAuthUserStatus === 'built-in_or_okta-oidc' || preAuthUserStatus === 'built-in_or_google-oidc')}
                                                                onChange={handleEmailFieldChange}
                                                                value={email}
                                                                validators={['required', 'isEmail']}
                                                                errorMessages={['your email is required', 'email is not valid']}
                                                            />
                                                            <div style={{minHeight: '10px', height: '10px'}}>
                                                                {isLoading && !preAuthUserStatus &&
                                                                    <QLoadingProgressBars numLines={1}/>
                                                                }</div>
                                                        </Grid>
                                                    </Grid>
                                                </FormGroup>
                                                {preAuthUserStatus && (preAuthUserStatus === 'built-in' || preAuthUserStatus === 'built-in_or_okta-oidc' || preAuthUserStatus === 'built-in_or_google-oidc') &&
                                                    <FormGroup>
                                                        <Grid container spacing={1} alignItems="flex-end">
                                                            <Grid item xs={1}/>
                                                            <Grid item xs={9} sm={10}>
                                                                    <LoginScreenPassword
                                                                        preAuthUserStatus={preAuthUserStatus}
                                                                        password={password}
                                                                        isLoading={isLoading}
                                                                        passwordVisibility={passwordVisibility}
                                                                        handleTogglePasswordVisibility={handleTogglePasswordVisibility}
                                                                        handlePasswordFieldChange={handlePasswordFieldChange}/>
                                                                <div style={{minHeight: '10px', height: '10px'}}>
                                                                    {isLoading && preAuthUserStatus &&
                                                                        <QLoadingProgressBars numLines={1}/>
                                                                    }</div>
                                                            </Grid>
                                                            {/*<Grid item>*/}
                                                            {/*    {passwordVisibility.password === false ?*/}
                                                            {/*        <AiOutlineEyeInvisible*/}
                                                            {/*            size="1.2em"*/}
                                                            {/*            style={{cursor: 'pointer'}}*/}
                                                            {/*            onClick={(e) => handleTogglePasswordVisibility(e, "password")}*/}
                                                            {/*        />*/}
                                                            {/*        :*/}
                                                            {/*        <AiOutlineEye*/}
                                                            {/*            size="1.2em"*/}
                                                            {/*            style={{cursor: 'pointer'}}*/}
                                                            {/*            onClick={(e) => handleTogglePasswordVisibility(e, "password")}*/}
                                                            {/*        />*/}
                                                            {/*    }*/}
                                                            {/*</Grid>*/}
                                                        </Grid>
                                                    </FormGroup>
                                                }
                                                <Grid container alignItems="center" justifyContent="flex-start"
                                                      spacing={2}>
                                                    <Grid item xs={1}/>
                                                    <Grid item xs={11}>
                                                        {preAuthUserStatus && (preAuthUserStatus === 'built-in' || preAuthUserStatus === 'built-in_or_okta-oidc' || preAuthUserStatus === 'built-in_or_google-oidc') &&
                                                            <Link component={RouterLink} style={{color: "#579FEE"}}
                                                                  to="/login/reset"><b>Forgot password?</b></Link>
                                                        }
                                                    </Grid>
                                                    <Hidden mdDown={true}>
                                                        <Grid item xs={1}><Box/></Grid>
                                                    </Hidden>
                                                    {/*<Grid item xs={1}><Box width="100%" paddingLeft={2}/></Grid>*/}
                                                    <React.Fragment>
                                                        <Grid item xs={6} sm={4}>
                                                            {/*<Grid item xs={4}/>*/}
                                                            {!preAuthUserStatus && !isLoading ?
                                                                <Button
                                                                    id={"nextButton"}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    disabled={!validateForm()}
                                                                    onClick={checkUserStatusForLogin}
                                                                >Next</Button>
                                                                : !isLoading && (preAuthUserStatus === 'built-in' || preAuthUserStatus === 'built-in_or_okta-oidc' || preAuthUserStatus === 'built-in_or_google-oidc') &&
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    disabled={!validateForm()}
                                                                    // onClick={checkUserStatusForLogin}
                                                                    type="submit">
                                                                    Log in</Button>
                                                            }
                                                        </Grid>
                                                    </React.Fragment>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Box pt={3}/>
                                                    <Divider/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Box pt={3}/>
                                                    Received an invite? <Link component={RouterLink}
                                                                              style={{color: "#579FEE"}}
                                                                              to="/login/set-password"><b>Accept
                                                    invite</b></Link>
                                                </Grid>
                                                <Grid item xs={12} md={9} lg={7}>
                                                    Don't have an account? <Link component={RouterLink}
                                                                                 style={{color: "#579FEE"}}
                                                                                 to='/signup'><b>Sign
                                                    up</b></Link>
                                                </Grid>
                                                <Grid item xs={12}>

                                                    {errorMessage &&
                                                        <React.Fragment><Box pt={2}/> <Alert severity={"error"}>
                                                            <AlertTitle>We ran into an issue.</AlertTitle>
                                                            {errorMessage}
                                                        </Alert>
                                                        </React.Fragment>
                                                    }
                                                </Grid>
                                                <Grid item xs={6}>
                                                </Grid>
                                                {/*</Grid>*/}
                                            </ValidatorForm>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        );
    }

    return (
        <div>
            <div>
                <Helmet>
                    <title>Log in | QFlow.ai</title>
                    <meta charSet="utf-8"/>
                    <script type="application/ld+json">{`
                    {
                              "@context": "https://schema.org",
                              "@type": "Organization",
                              "name": "QFlow.ai",
                              "url": "https://qflow.ai",
                              "address": {
                                 "@type": "PostalAddress",
                                 "streetAddress": "",
                                 "addressLocality": "San Francisco",
                                 "addressRegion": "CA",
                                 "postalCode": "94107",
                                 "addressCountry": "USA"
                                 },
                               "foundingDate": "2020",
                                 "founders": [
                                 {
                                 "@type": "Person",
                                 "name": "Alex Brower",
                                 "title": "Co-Founder",
                                 "alumniOf": "College of Wooster",
                                 "sameAs": "https://www.linkedin.com/in/alexbrower/",
                                  "gender": "Male",
                                "Description": "Technologist & Operator",
                                "address": {
                                    "@type": "PostalAddress",
                                    "addressLocality": "San Francisco",
                                    "addressRegion": "CA",
                                    "addressCountry": "USA"
                                    },
                                "image": "https://qflow.ai/qflow-logo.png"
                                 },
                                 {
                                 "@type": "Person",
                                 "name": "Vlad Kolpakov",
                                 "title": "Co-Founder",
                                 "alumniOf": "Yale",
                                
                                  "address": {
                                    "@type": "PostalAddress",
                                    "addressLocality": "San Francisco",
                                    "addressRegion": "CA",
                                    "addressCountry": "USA"
                                    }
                                 } ],
                                  "contactPoint": {
                                 "@type": "ContactPoint",
                                 "contactType": "customer support",
                                 "email": "appadmin@qflow.ai"
                                 },
                                "logo": "https://qflow.ai/qflow-logo.png",
                               "sameAs" : ["https://www.crunchbase.com/organization/qflow-ai","https://www.facebook.com/qflowai", "https://www.linkedin.com/company/qflow-ai","https://twitter.com/QFlowAI"] 
 }
                `}</script>

                    <link rel="alternate" hrefLang="en-us" href="https://qflow.ai/login"/>
                    <link rel="alternate" hrefLang="x-default" href="https://qflow.ai/login"/>
                    <meta name="description"
                          content="Log in to your secure QFlow.ai account."/>
                    <meta name="referrer" content="same-origin"/>
                    <link rel="apple-touch-icon" href="/logo192.png"/>
                    <meta name="author" content="QFlow.ai"/>
                    <meta name="theme-color" content="#ffffff"/>
                    <meta content="text/html; charset=UTF-8" name="Content-Type"/>
                    <meta name="twitter:site" content="@qflowai"/>
                    <meta name="twitter:card" content="summary_large_image"/>
                    <meta name="twitter:image"
                          content={`${config.REACT_APP_FRONTEND_HOST}/qflow-logo.png`}/>
                    <meta name="twitter:image:alt" content="QFlow.ai"/>
                    <meta name="twitter:title" content="QFlow.ai - Login"/>
                    <meta name="twitter:description"
                          content="Log into QFlow.ai, the ML platform that unifies data,
                           delivers analytics, and orchestrates intelligent behavior across
                            revenue-generating teams."/>
                    <meta property="og:type" content="website"/>

                    <meta property="og:site_name" content="QFlow.ai"/>
                    <meta property="og:title" content="QFlow.ai Login"/>
                    <meta property="og:image" content={`${config.REACT_APP_FRONTEND_HOST}/qflow-logo.png`}/>
                    <meta property="og:url" content="https://qflow.ai/login"/>
                    <meta property="og:description"
                          content="Log into QFlow.ai, the ML platform that unifies data,
                           delivers analytics, and orchestrates intelligent behavior across
                            revenue-generating teams."/>
                    <link rel="canonical" href="https://qflow.ai/login"/>
                </Helmet>

            </div>
            {!codeSent ? renderLoginForm() : renderConfirmationForm()}
            {/*{renderConfirmationForm()}*/}
        </div>
    )
}